<template>
  <div class="withdraw">
    <div class="manage">
      <div class="top-box">
        <div class="flexrbc">
          <div class="flexr0c">
            <div class="title-label"></div>
            <div class="title">资金提现</div>
          </div>
        </div>
      </div>
      <div class="search-box">
        <div class="flexr0c filter">
          <div class="label">时间范围</div>
          <Row>
            <Col span="12">
            <DatePicker :value="dateValues" format="yyyy/MM/dd" type="daterange" placement="bottom-end" placeholder="选择日期" style="width: 240px" @on-change="handleChange"></DatePicker>
            </Col>
          </Row>
          <div class="label">提现类型</div>
          <Select v-model="type" style="width:120px;margin-right:5px">
            <Option v-for="item in optionList" :value="item.value" :key="item.value">{{ item.name }}</Option>
          </Select>
          <div class="label">客户名称</div>
          <Select v-model="buyerId" style="width:200px;margin-right:10px">
            <Option v-for="item in userList" :value="item.buyerId" :key="item.buyerId">{{ item.buyerName }}</Option>
          </Select>
          <Button class="search-btn" @click="search" :loading="searchLoading">查询</Button>
        </div>
      </div>
      <div class="content-box">
        <div class="content">
          <div class="num-box">
            <div class="title-box flexr0c">
              <div class="title">待提现(元)</div>
              <div class="title">已提现(元)</div>
              <!-- <div class="title">可提现(元)</div> -->
            </div>
            <div class="item-box flexr0c">
              <div class="num">{{ moneyInfo.uncashAmount }}</div>
              <div class="num">{{ moneyInfo.cashAmount }}</div>
              <!-- <div class="num">{{ moneyInfo.cashAlivable }}</div> -->
            </div>
          </div>
          <div class="table-box">
            <div class="table">
              <Table :loading="loading" border stripe :columns="tableHead" :data="tableData"></Table>
              <div style="margin: 10px; overflow: hidden">
                <div style="float: right">
                  <Page :total="total" :page-size="pageSize" :current="1" @on-change="changePage" show-elevator show-total></Page>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 货款提现申请弹框 -->
    <Modal :closable="false" v-model="withdrawModal" title="提现" width="300">
      <p>
        <span>提现金额：</span>
        <span class="money">{{ withdrawMoney }}</span>
        <span>元</span>
      </p>
      <p class="moneyMsg">提示：请在 8:00 - 20:00 之间提现，其他时间段将无法提现！</p>
      <div slot="footer">
        <div style="display: flex;justify-content: center;">
          <Button style="width: 138px;" @click="cancelWithdraw">取消</Button>
          <Button style="width: 138px;background-image: linear-gradient(180deg, #478EE9 0%, #2255CE 100%);color: white;" :loading="withdrawLoading" @click="handleCashOut">确认提现</Button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: 'withdraw',
  data () {
    return {
      userInfo: {},
      pageIndex: 1,
      pageSize: 8,
      total: 0,
      withdrawMoney: 0,
      loading: true,
      tableHead: [
        {
          title: '企业名称',
          key: 'enterpriseName',
          width: 200
        },
        {
          title: '客户名称',
          key: 'buyerName',
          width: 180
        },
        {
          title: '类型',
          key: 'type',
          width: 120,
          render: (h, params) => {
            let txt;
            if (params.row.type == 1) {
              txt = '交易提现';
            } else if (params.row.type == 2) {
              txt = '货款提现';
            } else if (params.row.type == 3) {
              txt = '违约金提现';
            }
            return h('span', {}, txt);
          }
        },
        {
          title: '金额(元)',
          key: 'amount',
          width: 110,
          render: (h, params) => {
            return h('span', {}, params.row.amount.toFixed(2));
          }
        },
        {
          title: '确认状态',
          key: 'buyerConfirmState',
          width: 110,
          render: (h, params) => {
            let txt;
            if (params.row.buyerConfirmState == 0) {
              txt = '未确认';
            } else if (params.row.buyerConfirmState == 1) {
              txt = '已同意';
            } else if (params.row.buyerConfirmState == 2) {
              txt = '已驳回';
            } else {
              txt = '';
            }
            return h('span', {}, txt);
          }
        },
        {
          title: '确认时间',
          key: 'buyerConfirmTime',
          width: 180
        },
        {
          title: '状态',
          key: 'getCashState',
          width: 110,
          render: (h, params) => {
            let txt;
            if (params.row.getCashState == 0) {
              txt = '未提现';
            } else if (params.row.getCashState == 1) {
              txt = '提现中';
            } else if (params.row.getCashState == 2) {
              txt = '提现成功';
            } else {
              txt = '提现失败';
            }
            return h('span', {}, txt);
          }
        },
        {
          title: '备注',
          key: 'buyerConfirmRemark',
          width: 140,
          render: (h, params) => {
            if (params.row.buyerConfirmRemark && params.row.buyerConfirmRemark.length > 10) {
              return h('div', [
                h(
                  'Tooltip',
                  {
                    props: {
                      transfer: true,
                      theme: 'light'
                    }
                  },
                  [
                    h(
                      'span',
                      {
                        style: {
                          display: 'inline-block',
                          width: params.column._width * 0.9 + 'px',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap'
                        }
                      },
                      params.row.buyerConfirmRemark
                    ),
                    h(
                      'span',
                      {
                        slot: 'content',
                        style: { whiteSpace: 'normal', wordBreak: 'break-all' }
                      },
                      params.row.buyerConfirmRemark
                    )
                  ]
                )
              ]);
            } else {
              return h('span', {}, params.row.buyerConfirmRemark);
            }
          }
        },
        {
          title: '操作',
          slot: 'action',
          width: 80,
          fixed: 'right',
          render: (h, params) => {
            // 买方已同意and未提现状态
            if (params.row.buyerConfirmState == 1 && params.row.getCashState == 0) {
              return h('div', [
                h(
                  'Button',
                  {
                    props: {
                      type: 'success',
                      size: 'small'
                    },
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        this.id = params.row.id;
                        this.withdrawMoney = params.row.amount.toFixed(2);
                        this.withdrawModal = true;
                      }
                    }
                  },
                  '提现'
                )
              ]);
            }
          }
        }
      ],
      tableData: [],
      userList: [],
      optionList: [
        {
          name: '全部',
          value: 0
        },
        {
          name: '交易提现',
          value: 1
        },
        {
          name: '货款提现',
          value: 2
        },
        {
          name: '违约金提现',
          value: 3
        }
      ],
      buyerId: 0,
      userId: '',
      dateValues: [],
      withdrawModal: false,
      moneyInfo: {},
      searchLoading: false,
      withdrawLoading: false,
      type: 0,
      id: '',
      tableSelection: []
    };
  },
  created () {
    this.userId = JSON.parse(localStorage['session']).userId;
    const date2 = this.dateFormat('YYYY-mm-dd', new Date());
    this.dateValue = this.dateFormat('YYYY-mm-dd HH:MM:SS', new Date());
    this.dateValues.push(date2);
    this.dateValues.push(date2);
    this.getUserInfo();
    this.searchMoney();
  },
  methods: {
    search () {
      this.searchLoading = true;
      this.pageIndex = 1;
      this.getTableData();
    },
    handleChange (dateRange) {
      this.dateValues = dateRange;
    },
    dateFormat (fmt, date) {
      let ret;
      const opt = {
        'Y+': date.getFullYear().toString(), // 年
        'm+': (date.getMonth() + 1).toString(), // 月
        'd+': date.getDate().toString(), // 日
        'H+': date.getHours().toString(), // 时
        'M+': date.getMinutes().toString(), // 分
        'S+': date.getSeconds().toString() // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
      };
      for (let k in opt) {
        ret = new RegExp('(' + k + ')').exec(fmt);
        if (ret) {
          fmt = fmt.replace(ret[1], ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, '0'));
        }
      }
      return fmt;
    },
    cancelWithdraw () {
      this.withdrawModal = false;
      this.withdrawMoney = 0;
    },
    getUserInfo () {
      const session = JSON.parse(localStorage['session']);
      let data = {
        sessionId: session.sessionId,
        userId: session.userId,
        modeCode: '7e6OAiAvmLIjmLrJ5cpGKzjEhNJJhPWc'
      };
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          this.userList = res.data;
          this.userList.unshift({
            buyerName: '全部',
            buyerId: 0
          });
          this.userInfo = res.data;
          this.getTableData();
        } else {
          this.$Message['error']({
            background: true,
            content: res.msg
          });
        }
      });
    },
    searchMoney () {
      const session = JSON.parse(localStorage['session']);
      this.$http
        .post({
          sessionId: session.sessionId,
          userId: session.userId,
          enterpriseId: session.enterpriseId,
          buyerId: '',
          modeCode: 'MCKxkyeUzLYljGiFESlPgK9Gq2Fc1RxM'
        })
        .then((res) => {
          if (res.code == 1) {
            this.moneyInfo = {
              uncashAmount: res.data.uncashAmount || 0,
              cashAmount: res.data.cashAmount || 0,
              cashAlivable: res.data.cashAlivable || 0
            };
          } else {
            this.$Message['error']({
              background: true,
              content: res.msg
            });
          }
        });
    },
    getTableData () {
      const session = JSON.parse(localStorage['session']);
      let data = {
        sessionId: session.sessionId,
        userId: session.userId,
        enterpriseId: session.enterpriseId,
        modeCode: '9jtsYNGwaPQhOkWNepl99ChozW7VcURJ',
        createStartDate: this.dateValues[0],
        createEndDate: this.dateValues[1],
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        buyerId: this.buyerId == 0 ? '' : this.buyerId, //为全部时，置空。
        type: this.type == 0 ? '' : this.type // type 为全部时，置空。
      };
      this.$http.post(data).then((res) => {
        this.loading = false;
        this.searchLoading = false;
        if (res.code == 1) {
          this.total = res.data.count;
          this.tableData = res.data.result_ctn;
        } else {
          this.$Message['error']({
            background: true,
            content: res.msg
          });
        }
      });
    },
    chooseTable (selection) {
      this.tableSelection = selection;
    },
    changePage (page) {
      this.pageIndex = page;
      this.getTableData();
    },
    handleCashOut () {
      this.withdrawLoading = true;
      const session = JSON.parse(localStorage['session']);
      this.$http
        .post({
          modeCode: 'hSCo6MoqQM7rO0FEnwcMklFGKJ6d5Rr5',
          id: this.id,
          sessionId: session.sessionId,
          userId: session.userId,
          enterpriseId: session.enterpriseId
        })
        .then((res) => {
          this.withdrawLoading = false;
          if (res.code == 1) {
            this.withdrawModal = false;
            this.$Message['success']({
              background: true,
              content: '提现成功!'
            });
            this.getTableData();
          } else {
            this.$Message['error']({
              background: true,
              duration: 3,
              content: res.msg
            });
          }
        });
    }
  }
};
</script>

<style lang="less" scoped>
.withdraw {
  width: 980px;
  height: 100%;
  text-align: center;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  border-radius: 10px;
  margin-left: 20px;
  .manage {
    .top-box {
      background-image: linear-gradient(180deg, #ffffff 0%, #e8e9ea 100%);
      border-radius: 10px 10px 0 0;
      width: 100%;
      height: 40px;

      & > div {
        height: 100%;
        width: 928px;
        margin: 0 auto;
      }

      .title-label {
        width: 4px;
        height: 14px;
        background: #2c59c3;
      }

      .title {
        font-family: PingFangSC-Semibold;
        font-size: 16px;
        color: #2c59c3;
        letter-spacing: 0.4px;
        margin-left: 6px;
      }

      .addOrg {
        .btn {
          background-image: linear-gradient(180deg, #b4ec51 0%, #429321 100%);
          border-radius: 6px;
          cursor: pointer;
          width: 110px;
          height: 30px;
          line-height: 30px;
          margin: 0 4px;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #ffffff;
          letter-spacing: 0.35px;
          &:hover {
            background-image: linear-gradient(180deg, #c4ff5b 0%, #4aa824 100%);
          }
        }
      }
    }

    .search-box {
      /deep/.ivu-select-placeholder {
        text-align: start;
      }

      .filter {
        margin-top: 18px;
        margin-bottom: 14px;

        .label {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #616c84;
          margin: 0 10px 0 26px;
        }

        /deep/.ivu-date-picker-focused input,
        /deep/.ivu-date-picker-focused input {
          font-size: 14px;
        }

        /deep/.ivu-select-selected-value,
        /deep/.ivu-select-item {
          text-align: start;
        }

        /deep/.ivu-input-with-suffix {
          cursor: pointer;
        }

        /deep/.ivu-select-selection {
          height: 38px;
          background: #ffffff;
          box-shadow: inset 0 4px 8px 0 rgba(0, 0, 0, 0.07);
          border-radius: 8px;
        }

        /deep/.ivu-select-placeholder,
        /deep/.ivu-select-selected-value {
          height: 38px;
          line-height: 38px;
          padding-left: 24px;
          text-align: start;
        }

        /deep/.ivu-input-suffix {
          line-height: 38px;
        }

        /deep/.ivu-input-with-suffix {
          height: 38px;
          line-height: 38px;
          padding-left: 24px;
          background: #ffffff;
          box-shadow: inset 0 4px 8px 0 rgba(0, 0, 0, 0.07);
          border-radius: 8px;
        }

        .search-btn {
          background-image: linear-gradient(180deg, #91caff 0%, #0074d6 97%);
          border: 1px solid #006bc4;
          border-radius: 6px;
          width: 80px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #ffffff;
          letter-spacing: 0.35px;
          cursor: pointer;
          margin-left: 20px;

          &:hover {
            background-image: linear-gradient(180deg, #cce7ff 0%, #027de6 97%);
          }
        }
      }
    }

    .content-box {
      width: 980px;
      height: 100%;
      background: #ffffff;
      box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
      overflow: hidden;
      border-radius: 10px;

      .content {
        width: 928px;
        margin-top: 30px;

        .title-box:first-child {
          background-color: #fff;
          margin: 10px 0 15px;
        }

        .title-box {
          width: 928px;
          height: 40px;
          background-color: rgba(224, 229, 240, 0.3);

          .title {
            font-family: PingFangSC-Semibold;
            font-size: 16px;
            color: #8b93a7;
            flex: 1;
            .cashAmount {
              color: #ed4014;
              font-size: 20px;
              font-weight: 600;
            }
            .cashAlivable {
              color: #19be6b;
              font-size: 20px;
              font-weight: 600;
            }
          }
        }

        .num-box {
          position: relative;
          .title-box {
            background: rgba(224, 229, 240, 0.3);
          }
          .num {
            font-family: Impact;
            font-size: 24px;
            flex: 1;
            margin: 20px 0;
            color: #2c59c3;
            text-align: center;
          }
          .num-but {
            position: absolute;
            right: 10px;
          }
        }

        /deep/ .ivu-table th {
          background-image: linear-gradient(180deg, #2f66ba 0%, #153684 100%);
          color: #fff;
        }

        /deep/ .ivu-table th:last-child {
          border-top-right-radius: 10px;
          background-image: linear-gradient(180deg, #2f66ba 0%, #153684 100%);
          color: #fff;
        }

        /deep/ .ivu-table th:first-child {
          // border-top-left-radius: 10px;
          background-image: linear-gradient(180deg, #2f66ba 0%, #153684 100%);
          color: #fff;
        }
      }
    }
  }
  /deep/.ivu-table-wrapper-with-border {
    border-radius: 12px;
  }

  /deep/.ivu-select-selected-value,
  /deep/.ivu-select-item {
    text-align: start;
    border-bottom: 1px solid #fafafa;
  }

  /deep/span.ivu-select-selected-value {
    border-bottom: none;
  }

  /deep/.ivu-select-item:last-child {
    border-bottom: none;
  }

  /deep/.ivu-radio-checked {
    color: #2c59c3;
  }

  /deep/.ivu-table-stripe .ivu-table-body tr:nth-child(2n) td,
  .ivu-table-stripe .ivu-table-fixed-body tr:nth-child(2n) td {
    background-color: rgba(236, 241, 247, 0.4);
  }

  /deep/.ivu-table-stripe .ivu-table-body tr.ivu-table-row-hover td,
  .ivu-table-stripe .ivu-table-fixed-body tr.ivu-table-row-hover td {
    background: rgba(255, 255, 235, 0.15) !important;
  }

  /deep/.ivu-table-row-hover {
    background: rgba(255, 255, 235, 0.15) !important;
  }

  /deep/.ivu-input-with-suffix {
    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.07);
  }

  /deep/.ivu-table-wrapper-with-border {
    border-radius: 12px;
    border: 1px solid #dcdee2;
    border-right: none;
  }

  /deep/.ivu-table td,
  .ivu-table th {
    border-bottom: none;
  }

  /deep/.ivu-table:before {
    display: none;
  }

  input:disabled {
    border: 1px solid rgba(118, 118, 118, 0.3);
    box-shadow: none;
  }

  /deep/.ivu-input-wrapper {
    width: 100%;
  }
}

.money {
  color: #ed4014;
  font-size: 22px;
  font-weight: 600;
  margin-right: 5px;
}

.moneyMsg {
  color: #ff9900;
}
</style>
